import classNames from "classnames";
import { useState } from "react";
import type { BlockAppointmentFields, PersistedAppointment } from "schemas";
import { Drawer, Loader, TextAccent, TextMain, flexStyles, paddingStyles } from "ui";
import { useAppointments } from "../../../../store";
import { Button, RadioCard } from "../../../ui";

interface Props {
  onClose: () => void;
  onAppointmentSelected: (props: BlockAppointmentFields) => void;
}

export function SelectAppointmentDrawer({ onClose, onAppointmentSelected }: Props) {
  const { appointments, loading } = useAppointments(); // Assuming hook returns { appointments, loading }
  const [selectedAppointment, setSelectedAppointment] = useState<PersistedAppointment | null>(null);

  const handleSelectAppointment = (appointment: PersistedAppointment) => {
    setSelectedAppointment(appointment);
  };

  const handleSave = () => {
    if (selectedAppointment) {
      onAppointmentSelected({
        appointmentId: selectedAppointment.id,
        header: selectedAppointment.name,
        description: selectedAppointment.description || "",
        label: selectedAppointment.formattedPrice ? `Schedule for ${selectedAppointment.formattedPrice}` : "Schedule",
        url: selectedAppointment.url,
        image: selectedAppointment.image ? `${selectedAppointment.image}/feed` : "",
        tags: JSON.stringify(selectedAppointment.tags),
      });
    }
  };

  return (
    <Drawer onClose={onClose} title="Select Appointment" open={true}>
      {loading ? (
        <Loader />
      ) : (
        <div className={paddingStyles.py125}>
          <div className={flexStyles.vert125}>
            <TextMain>Choose an appointment to link</TextMain>

            <div className={flexStyles.vert050}>
              {appointments.length === 0 ? (
                <>
                  <TextAccent>No appointments found</TextAccent>
                  {/* Assuming a route like /appointments/new exists */}
                  <Button to="/appointments/new" buttonType="secondary">
                    Create an appointment first
                  </Button>
                </>
              ) : (
                appointments.map((appointment) => (
                  <RadioCard
                    key={appointment.id}
                    onClick={() => handleSelectAppointment(appointment)}
                    title={<TextAccent>{appointment.name}</TextAccent>}
                    checked={selectedAppointment?.id === appointment.id}
                  />
                ))
              )}
            </div>

            <div className={classNames(flexStyles.horizApart)}>
              <Button onClick={handleSave} disabled={!selectedAppointment}>
                Insert Appointment
              </Button>
              <Button buttonType="tertiary" onClick={onClose}>
                Cancel
              </Button>
            </div>
          </div>
        </div>
      )}
    </Drawer>
  );
}
